export default __webpack_public_path__ + "static/media/doctor4.bf51e704.jpg";